import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../hooks/redux";
import { Button as AlchemyButton } from "@amzn/alchemy-components-react";
import { setMobileView } from "../slices/mobileViewSlice";
import { setUser } from "../slices/userSlice";
import i18n from "../i18n";
import stage, { currentStage } from "../stages.const";
import TokenRetriever from "./Authentication/TokenRetriever";
import parseJwt from "../utils/jwt-parser";
import FeedbackModal from "./FeedbackView";
import MessageContainer from "./MessageContainer";
import CreateBookmarkModal from "./Modals/CreateBookmarkModal";
import EditBookmarkModal from "./Modals/EditBookmarkModal";
import ViewBookmarkModal from "./Modals/ViewBookmarkModal";
import Navigation from "./Navigator";
import SystemMessageContainer from "./SystemMessage";
import useWindowDimensions from "./Utils/WindowsDimention";
import { analytics } from "../utils/analytics";

export default function () {
  const { height, width } = useWindowDimensions();
  const [loadingUser, setLoadingUser] = useState(true);
  // prepare inital load
  const dispatch = useAppDispatch();

  // Get and set the token - runs only once on component mount
  useEffect(() => {
    // Create TokenRetriever inside the effect to avoid potential re-render issues
    const tr = new TokenRetriever(stage);

    const getToken = async () => {
      try {
        const token = await tr.getTokenOrRedirect();
        
        // Extract user information from the JWT token
        if (token && token !== "Loading token..." && token !== "Error fetching token") {
          const tokenData = parseJwt(token as string);
          console.log("JWT Token data:", tokenData);
          
          // Parse user information from token
          const userData = {
            login: tokenData.sub,
            // Reformat name from "Last, First(Nickname)" to "First(Nickname), Last"
            fullName: tokenData.DISPLAY_NAME ? 
              tokenData.DISPLAY_NAME.replace(/^([^,]+), (.+)$/, "$2, $1") : 
              "",
            whid: tokenData.BUILDING_CODE,
            managerLogin: tokenData.MANAGER_LOGIN,
            // Manager's full name is hard-coded for known managers
            managerName: tokenData.MANAGER_LOGIN 
          };
          
          // Dispatch to Redux store
          dispatch(setUser(userData));
          setLoadingUser(false);
          
          // Track user session start once per session
          analytics.trackSessionStart();
        }
      } catch (error) {
        console.error("Token retrieval error:", error);
      }
    };

    // Call immediately
    getToken();

    // No cleanup needed as this effect only runs once
  }, []); // Empty dependency array ensures this runs only once on mount
  // detect whether mobile view
  useEffect(() => {
    const isMobile = width < 1024;
    dispatch(setMobileView(isMobile));
  }, [height, width]);
  
  // Back to top
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // Modals
  const importModals = () => {
    return (
      <>
        <EditBookmarkModal />
        <MessageContainer />
        <CreateBookmarkModal />
        <ViewBookmarkModal />
        <FeedbackModal />
      </>
    );
  };

  if (loadingUser) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        Loading user information...
      </div>
    );
  }

  return (
    <>
        <Navigation />
      <div className="back-to-top">
        {showTopBtn && (
          <AlchemyButton variant="action" onClick={goToTop}>
            {i18n.t("universal:top")}
          </AlchemyButton>
        )}
      </div>
      {importModals()}
    </>
  );
}
